<template>
    <div class="hotspot">
        <Modal ref="modal" v-model="startModal">
            <div class="info-box-modal-content disable-info-icon">
                <p>
                    <slot name="question" />
                </p>
                <p class="text-center">
                    <ControlButton active data-close>
                        Weiter
                    </ControlButton>
                </p>
            </div>
        </Modal>
        <div>
            <transition
                name="fade"
                appear
            >
                <h3 v-if="$parent.content0Visible" class="title text-thin">
                    <slot name="question" />
                </h3>
            </transition>
            <Magnifier v-if="$parent.content1Visible" :size="6" />
        </div>
        <div class="content-wrapper">
            <SlideInTransition v-show="$parent.content2Visible" from="left">
                <div class="side left">
                    <img
                        :src="require('@/assets/modules/2.2/medien_infografik.png')"
                        class="block image"
                    >
                    <transition
                        name="fade"
                        appear
                    >
                        <div
                            v-if="showHotspotItems && $parent.content6Visible"
                            class="highlight"
                        >
                            <div
                                :style="config.styles.circle"
                                class="highlight-circle"
                            />
                            <div
                                :style="config.styles.bubble"
                                class="highlight-bubble"
                            >
                                <slot name="answer" />
                            </div>
                        </div>
                    </transition>
                    <InfoBox active>
                        <template #header>
                            Quelle
                        </template>
                        Theunert, H., & Demmler, K. (2007). (Interaktive) Medien im
                        Leben Null- bis
                        Sechsjähriger – Realitäten und Handlungsnotwendigkeiten. <br>In: B.
                        Herzig &
                        S. Grafe (Hrsg.),
                        <i>
                            Digitale Medien in der Schule. Standortbestimmung und
                            Handlungsempfehlungen für die Zukunft. Studie zur Nutzung digitaler
                            Medien
                            in allgemein bildendenden Schulen in Deutschland
                        </i>
                        (S. 137-145). Bonn: Deutsche Telekom. Angelehnt an die Grafik „Was
                        können
                        Kinder in welchem Alter mit Medien machen?“<br>(S. 141), überarbeitet
                        von Marc
                        Doerfert (Helliwood media & education) und KIDS interactive GmbH.
                    </InfoBox>
                </div>
            </SlideInTransition>
            <SlideInTransition v-show="$parent.content3Visible" from="right">
                <div class="side right">
                    <img
                        :src="require('@/assets/modules/2.2/medien_infografik_legende.png')"
                        class="block image"
                    >
                </div>
            </SlideInTransition>
        </div>
    </div>
</template>

<script>
import SlideState from '@/mixins/SlideState';

export default {
    name: 'HotSpot',
    mixins: [SlideState],
    props: {
        config: {
            type: Object,
            required: true
        },
        modalOpen: {
            type: Boolean,
            required: false
        }
    },
    data: () => (
        {
            startModal: false,
            showHotspotItems: false
        }),
    watch: {
        '$parent.content1Visible': function()
        {
            this.startModal = !this.getState();
        }
    },
    created()
    {
        if (this.getState())
        {
            this.showAnswer();
            return;
        }
        this.$parent.setNextButtonActive(true, 'Zur Auflösung', () =>
        {
            this.saveState(true);
            this.showAnswer();
            this.$audioController.play('reveal', {volume: 0.4});
        });
    },
    methods: {
        showAnswer()
        {
            this.showHotspotItems = true;
            this.$parent.setNextButtonActive(true);
        }
    }
};
</script>

<style lang="scss" src="./Hotspot.scss" />

